import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const Modal = ({ isOpen, onClose, children }) => {
  const [modalRoot, setModalRoot] = useState(null);

  useEffect(() => {
    let root = document.getElementById('modal-root');
    if (!root) {
      root = document.createElement('div');
      root.id = 'modal-root';
      document.body.appendChild(root);
    }
    setModalRoot(root);
  }, []);

  useEffect(() => {
    if (isOpen) {
      // Blocca lo scrolling quando la modale è aperta
      document.body.classList.add('overflow-hidden');
    } else {
      // Riabilita lo scrolling quando la modale è chiusa
      document.body.classList.remove('overflow-hidden');
    }

    // Cleanup per rimuovere la classe quando il componente viene smontato
    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, [isOpen]);

  if (!isOpen || !modalRoot) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4 md:p-16">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-3xl sm:max-w-lg p-4  md:p-8 relative overflow-y-auto  flex flex-col">
        {children}
      </div>
    </div>,
    modalRoot
  );
};

export default Modal;
